
import Vue from 'vue';
import store from '@/store';
import { Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Action, Getter } from 'vuex-class';
import { Block } from '@/types/block';
import { startCase } from 'lodash';
import BlockListTile from '@/components/Block/BlockListTile.vue';

@Component({
  components: { BlockListTile },
})
export default class BlockList extends Vue {
  @Action('blocks/getBlocks') getBlocks!: Function;
  @Getter('blocks/blocks') blocks!: Block[];

  get pageName(): any {
    const name = this.$route.name || undefined;
    return startCase(name);
  }

  newBlock() {
    this.$router.push('/blocks/editor');
  }

  async beforeRouteEnter(to: Route, from: Route, next: Function) {
    await store.dispatch('blocks/getBlocks');
    next();
  }
}
